import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import * as dashboardActions from "store/entities/dashboard/action";
import * as accountActions from "store/auth/account/action";
import * as walletAction from "store/entities/wallet/action";

// import SettingsTab from 'components/__new/settings/tab';
import Table from 'components/__new/common/Table';
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
// import IconLock from "assets/images/icons/project-icons/lock.svg";
import { capitalizeFirstLetter, convertToTitleCase } from "utils/stringFormatter";
import pen from "assets/images/icons/pen-icon.svg";
// import testpic from "assets/images/icons/profile-picture-test.jpg";
import PageContent from "components/__new/common/PageContent";
import Maybe from "components/__new/common/Maybe";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import ProfilePictureModal from 'components/__new/common/form/ProfilePictureModal';
import PersonalInfoModal from "components/__new/common/form/PersonalInfoModal";
import { nameInitials } from 'utils/nameInitials';
import ContentLoading from "components/__new/common/ContentLoading";
import pencilIcon from "assets/images/icons/pencil-icon.svg";


const Profile = () => {
    // const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    // const { profileUpdated } = useSelector((s) => s.auth.account);
    
    const {dashboard, dashboardLoading} = useSelector(state => state.entities.dashboard);
    const { editTeamMember } = useSelector((state) => state.entities.settingsInfo);
    // const profileImage = dashboard?.employer?.profileImage
    
    const profileImage = dashboard?.member?.profileImage;
    const firstName = dashboard?.member?.firstName;
    const lastName = dashboard?.member?.lastName;
    const email = dashboard?.member?.email
    const role = dashboard?.member?.roleId
    // const email = dashboard?.employer?.email
    
    
    const { InlineRouterTab } = useInlinePageRouter();
    const [isOpenProfilePictureModal, setIsOpenProfilePictureModal] = useState(false);
    const [isPersonalInfoModal, setIsPersonalInfoModal] = useState(false);
    const [isEdited, setIsEdited] = useState(false);

    useEffect(() => {
        // if (profileUpdated?.status === "success"){
        if ((editTeamMember?.error === false ) && isEdited){
            toast.success("Profile updated successfully");
            setIsPersonalInfoModal(false)
            setIsOpenProfilePictureModal(false)
            setIsEdited(false)
            dispatch(dashboardActions.getDashboard())
        }
        // eslint-disable-next-line
    }, [editTeamMember]);


    const queryOptions = [
        {
            title: "Profile Information",
            path: "/settings/profile",
        },
        {
            title: "Company Details",
            path: "/settings/info",
        },
        {
            title: "Teams",
            path: "/settings/team-management",
        },
        {
            title: "Role Management",
            path: "/settings/team-management/roles",
        },
        {
            title: "On-Demand Pay",
            path: "/settings/ondemand-pay",
        },
        {
            title: "Login & Security",
            path: "/settings/login-security",
        },
        // {
        //     title: "Notifications",
        //     path: "/settings/notifications",
        // },
    ]
    
    const handleProfilePictureClick = () => {
        // if(dashboard?.member?.userType === "employer"){
            setIsOpenProfilePictureModal(true)
        // }
    }
    
    const handleProfileEdit = () => {
        // if(dashboard?.member?.userType === "employer"){
            setIsPersonalInfoModal(true)
        // }
    }

    return ( 
        <div>
            <DynamicHeadTag
                headerText="Profile | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />

            <ProfilePictureModal
                isOpen={isOpenProfilePictureModal}
                setIsOpen={setIsOpenProfilePictureModal}
                dashboard={dashboard}
                dashboardLoading={dashboardLoading}
                isEdited={isEdited}
                setIsEdited={setIsEdited}
            />

            <PersonalInfoModal 
                isOpen={isPersonalInfoModal}
                setIsOpen={setIsPersonalInfoModal}
                dashboard={dashboard}            
                dashboardLoading={dashboardLoading}
                isEdited={isEdited}
                setIsEdited={setIsEdited}
            />

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title text-ep-deep-dark">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>

            <div className="mt-6 w-full">
                <InlineRouterTab
                    items={queryOptions}
                />
            </div>
            

            <div className="mt-6 p-4 sm:p-6 bg-white" style={{borderRadius: '12px'}}>
                
                    <div className="max-w-full">
                        {/* <form onSubmit={submitForm}></form> */}
                            
                        <div className="flex justify-between">
                            <h3 style={{ fontSize: '18px', lineHeight: '28px' }}  className="font-bold text-ep-black">
                                Profile Information
                            </h3>
                        </div>
                        <PageContent
                            loading={dashboardLoading}
                            data={dashboard}
                            loadingText="Loading profile information..."
                            emptyText="Profile information not found"
                            errorText="Unable to fetch profile information"
                        />
                        <Maybe condition={dashboardLoading === false && dashboard}>
                            <div className="p-2 mt-10 border border-ep-rule rounded-lg">
                                <Table className="w-full mb-6">
                                    <Table.Head>
                                        <th style={{border: '0px', backgroundColor: 'transparent',  width: "200px", fontSize: '16px', fontWeight: 500, lineHeight: '18.24px',}} className="border-transparent bg-ep-primary-300 text-ep-gray-300 font-medium">Profile Picture</th>
                                        <th style={{border: '0px', backgroundColor: 'transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', }} className="font-normal text-left ">Add a picture to personalize your profile</th>
                                        <th style={{border: '0px', backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end", paddingRight: "122px",  fontSize: '16px', fontWeight: 500, lineHeight: '21px', }} className="font-medium relative">
                                            <button style={{right: '122px', top: '10px'}} className="rounded-full flex justify-center border-1 border-ep-primary-50 items-center bg-ep-primary-600 text-sm absolute top-0 right-0 z-10 w-4 h-4  font-normal text-white" onClick={handleProfilePictureClick}>
                                                <img className=' cursor-pointer w-2 h-2' src={pencilIcon} alt="edit" />
                                            </button>
                                            <button className='cursor-pointer' onClick={handleProfilePictureClick}>
                                                {!profileImage ? 
                                                    <ContentLoading
                                                        loading={dashboardLoading}
                                                        data={
                                                            <div className='flex justify-center items-center rounded-full text-center text-white bg-ep-primary p-6'
                                                            style={{
                                                                borderRadius: '50%',
                                                                width: '48px',
                                                                height: '48px',
                                                                fontSize: "20px",
                                                            }}>
                                                            {nameInitials(firstName, lastName)}
                                                        </div>
                                                    }
                                                />
                                                : <img 
                                                    // className='h-12 w-12' 
                                                    src={profileImage} 
                                                    alt="user avatar" 
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '48px',
                                                        height: '48px',
                                                        objectFit: 'cover',
                                                    }}
                                                />}
                                            </button>
                                        </th>
                                    </Table.Head>
                                </Table>
                                
                                <hr className='pb-5'/>
                                
                                <Table className="w-full mt-6">
                                        <Table.Head>
                                            <th style={{border: '0px', backgroundColor: 'transparent',  width: "200px", fontSize: '16px', fontWeight: 500, lineHeight: '18.24px',}} className="border-transparent bg-ep-primary-300 text-ep-gray-300 font-medium">Personal Info</th>
                                            <th style={{border: '0px', backgroundColor: 'transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', }} className="font-normal text-left text-ep-gray-600">Manage your personal information</th>
                                            <th style={{border: '0px', backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end", paddingRight: "122px",  fontSize: '16px', fontWeight: 500, lineHeight: '21px', }} className="">
                                                <button type="button" onClick={handleProfileEdit} style={{fontWeight: 500}} className="flex items-center text-ep-primary underline"><img src={pen} alt="pen-icon"/>Edit</button>
                                            </th>
                                        </Table.Head>
                                    <Table.Body>
                                        <tr>
                                            <td style={{border: '0px solid transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px'}} className="text-ep-gray-500">First Name</td>
                                            <td style={{border: '0px solid transparent', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="font-medium">{capitalizeFirstLetter(firstName) || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{border: '0px solid transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px'}} className="text-ep-gray-500">Last Name</td>
                                            <td style={{border: '0px solid transparent', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }}className="font-medium">{capitalizeFirstLetter(lastName) || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{border: '0px solid transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px' }} className="text-ep-gray-500">Phone Number</td>
                                            <td style={{border: '0px solid transparent', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="">{dashboard?.member?.phoneNumber || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{border: '0px solid transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px' }} className="text-ep-gray-500">Email Address</td>
                                            <td style={{border: '0px solid transparent', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="font-medium">{email || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{border: '0px solid transparent', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px' }} className="text-ep-gray-500">Job Title</td>
                                            <td style={{border: '0px solid transparent', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }}className="font-medium">{dashboard?.member?.jobTitle || '-'}</td>
                                        </tr>
                                    </Table.Body>
                                </Table>
                            </div>
                        </Maybe>
                    </div>
            </div>    
        </div>    
    )
}

export default Profile;
